import { Component, ComponentChildren } from 'preact';
import { Store } from '@accedo/general-store';
import { OipfObjectFactory } from '@accedo/oipf-utils';
import appConfig from '../../../config/app/hbbtv';
import { StoreContext, Config } from './types';


export type VideoBroadcastElement = HTMLObjectElement & {
  bindToCurrentChannel?: () => void;
  stop?: () => void;
  release: () => void;
  setChannel: (
    channel?: any,
    trickplay?: boolean,
    contentAccessDescriptorURL?: string,
    quiet?: 0 | 1 | 2,
  ) => void;
};

export interface ObjectFactory extends OipfObjectFactory {
  createVideoBroadcastObject: () => VideoBroadcastElement;
}

declare global {
  interface Window {
    fastdom: Fastdom;
    fastdomPromised: FastDomPromised;
    appConfig: string;
    FoxtelAppMessaging?: FoxtelAppMessaging;
  }
}

const dom = window.fastdom.extend(window.fastdomPromised);
export const config = new Store<Config>();

dom.initialize();
config.$set(appConfig[process.env.APP_ENV || 'prod']);

type ShowDetailsCache = {
  epId: string;
  seasonTitle: string;
  isExtra: boolean;
  selectedExtra?: string;
  favouriteOnMount?: boolean;
};

type ShowLandingFocusCache = {
  genreKey: string;
  showId: string;
};

type SearchPageCache = {
  searchTerm: string;
  lastFocusShowId: string;
};

type HomeFocusCache = {
  lastScrollPosition: number;
  scrollToPrevious: boolean;
  lastFocusId: string;
};

type LivePageCache = {
  lastFocusChannelId: string;
  lastFocusedElementId: string;
  lastChannelIdx: number;
  isComingUp: boolean;
  Later: boolean;
};

type NewsPageCache = {
  lastFocusId: string;
  prevRegion: string;
};

type ActivationScreenCache = {
  signInDeeplinked: boolean;
};

export const focusCache = {
  tvShowDetails: new Store<ShowDetailsCache>(),
  tvShowLanding: new Store<ShowLandingFocusCache>(),
  search: new Store<SearchPageCache>(),
  home: new Store<HomeFocusCache>(),
  livePage: new Store<LivePageCache>(),
  newsPage: new Store<NewsPageCache>(),
  activationScreen: new Store<ActivationScreenCache>(),
};
type VODCounterType = {
  episodeCount: number;
};

export const VODCounter = new Store<VODCounterType>();

export class StoreProvider extends Component {
  // eslint-disable-next-line class-methods-use-this
  getChildContext(): StoreContext {
    return {
      dom,
    };
  }

  render(): ComponentChildren {
    return this.props.children;
  }
}
